import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import ExpandIcon from '@material-ui/icons/KeyboardArrowDown'
import CollapseIcon from '@material-ui/icons/KeyboardArrowUp'

import StyleSheet from 'styles'
import Table, { TableBody, TableRow, TableCell, styles as tableStyles } from 'components/CollapsibleTable'
import { ImageAvatar } from 'components'
import { StatusTag } from 'components/deal_sheet'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import AllocationDetails from './AllocationDetails'
import IconButton from '@material-ui/core/IconButton'
import { SectionLoader } from 'components'
import {NumberDisplay} from 'components/numbers'
import {injectIntl} from 'react-intl'

export class DealsList extends Component {
  static propTypes = {
    deals: PropTypes.array.isRequired,
    dealSheetDetails: PropTypes.object.isRequired,
    mapDealToActions: PropTypes.func.isRequired,
    onDealSheetClick: PropTypes.func,
  }

  static defaultProps = {
    deals: [],
    mapDealToActions: (deal) => []
  }

  constructor(props) {
    super()
    this.state = {
      actionsMenuOpenForDealSheetId: null,
      anchorEl: null,
      expandedDeals: {}
    }
  }

  renderAvatar = (deal) => {
    const { issuerAccountName, emblemUrls } = deal
    return <ImageAvatar alt={ issuerAccountName } urls={ emblemUrls } className={styles.avatarImage}/>
  }

  renderDealStatus = (deal) => {
    const { status } = deal
    return (
      <StatusTag status={ status } className={ styles.statusTag } />
    )
  }

  rowStyles = (deal) => {
    if (this.state.expandedDeals[deal.id])
      return { }
    else
      return { display: 'none' }
  }

  toggleExpanded = (deal) => {
    if (!this.props.dealSheetDetails[deal.id])
      this.props.fetchDetails(deal)

    this.setState({
      expandedDeals: {
        ...this.state.expandedDeals,
        [deal.id]: !this.state.expandedDeals[deal.id]}
    })
  }

  renderDeal = (deal) => {
    const { intl } = this.props
    const { id, currency, name, ticker } = deal
    const dealSheetDetails = this.props.dealSheetDetails[deal.id]
    const { expandedDeals: {[deal.id]: expanded} } = this.state
    const currencyCode = currency ? currency.code : ''
    const ownAmountAllocated = Number(deal.ownAmountAllocated)
    const ownAmountClaimed = Number(deal.ownAmountClaimed)

    return (
      <Fragment key={ id }>
        <TableRow>
          <TableCell mobileHeading>
            <div className={ styles.avatar } onClick={() => this.props.history.push(`/deal_sheets/${deal.id}/`)}>
              { this.renderAvatar(deal) }
              <Typography variant='subtitle1' className={ styles.tagLine }>{name} <span style={{fontWeight: 500}}>{ticker && `(${ticker})`}</span></Typography>
            </div>
          </TableCell>
          <TableCell mobileLabel={intl.formatMessage({id: 'deals.table.heading.allocation'})}>
            {ownAmountAllocated ?
              <Link to={`/deal_sheets/${deal.id}/allocations`} onClick={e => e.stopPropagation()}>
                <NumberDisplay>{ownAmountClaimed}</NumberDisplay> / <NumberDisplay>{ownAmountAllocated}</NumberDisplay> {currencyCode}
              </Link>
              :
              '\u2014'
            }
          </TableCell>
          <TableCell mobileHeading style={{textAlign: 'right'}}>
            { this.renderDealStatus(deal) }
          </TableCell>
          <TableCell mobileHeading className={styles.actionButtons}>
            {(Number(deal.ownAmountAllocated) > 0 || Number(deal.ownAmountNominated) > 0) &&
            <IconButton onClick={() => this.toggleExpanded(deal)}>{expanded ? <CollapseIcon/> : <ExpandIcon/>}</IconButton>
            }
          </TableCell>
        </TableRow>
        {expanded &&
          <TableRow key={`${id}-details`} className={tableStyles.details}>
            <TableCell colSpan={100}>
              {dealSheetDetails ?
                <AllocationDetails dealSheet={deal} {...this.props.dealSheetDetails[deal.id]}/>
                :
                <SectionLoader />
              }
            </TableCell>
          </TableRow>
        }
      </Fragment>
    )
  }

  render = () => {
    return (
      <div className={styles.list}>
        <Table>
          <TableBody>
            {this.props.deals.map(deal =>
              this.renderDeal(deal)
            )}
          </TableBody>
        </Table>
      </div>
    )
  }
}

const styles = StyleSheet({
  list: {
    paddingTop: 8,
    width: '100%',
    '& table.collapsed': {
      '& $avatarImage': {
        marginRight: 0
      },
    }
  },
  avatar: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  avatarImage: {
    marginRight: 20
  },
  tagLine: {
    paddingLeft: 8,
    fontSize: '16px',
    fontWeight: 700,
    color: '#464646',
    '@media(min-width: 800px)': {
      whiteSpace: 'nowrap',
    }
  },
  dealStatus: {},
  statusTag: {},
  dealStatusCollapsed: {
    '& $statusTag':{
      float: 'left'
    }
  },
  expandHandler: {
    width: 16,
  },
  expandHandlerCollapsed: {
    '& $expandHandler':{
      left: '-16px'
    }
  },
  actionButtons: {
    width: 1,
  },
})

export default withRouter(injectIntl(DealsList))